import * as React from 'react';

import { ButtonVariant } from '../../BaseComponents/Button/types';
import Segment from './Segment/Segment';
import { useTheme } from '../../theme';
import { SegmentFragment, ResultsLegFragment } from '@websky/graphql';
import { BaseButton } from '../../BaseComponents';

interface Props {
	flight: ResultsLegFragment;
	onButtonClick?: () => void;
	renderPreFooter?: () => React.ReactNode;
	buttonText?: string;
	buttonType?: ButtonVariant;
	isReturnFlight?: boolean;
}

const FlightInfo: React.FunctionComponent<Props> = ({
	flight,
	onButtonClick,
	buttonText = '',
	buttonType = 'common',
	renderPreFooter,
	isReturnFlight
}) => {
	const { DesktopFlightInfo: css } = useTheme('DesktopFlightInfo');
	const getNextSegment = (index: number): SegmentFragment => flight.segments[index + 1].segment;

	return (
		<div className={css.info}>
			<div className={css.segments}>
				{flight.segments.map(({ segment, transferDuration }, index) => (
					<Segment
						key={index}
						segment={segment}
						transferDuration={transferDuration}
						nextSegment={transferDuration ? getNextSegment(index) : undefined}
						isReturnFlight={isReturnFlight}
					/>
				))}
			</div>

			{renderPreFooter && renderPreFooter()}

			{onButtonClick && (
				<div className={css.footer}>
					<BaseButton variant="optionEdit" onClick={onButtonClick} classes={{ root: css.button_default }}>
						{buttonText}
					</BaseButton>
				</div>
			)}
		</div>
	);
};

export default FlightInfo;
